import type {HTMLAttributes, PropsWithChildren, ReactElement, ReactHTML} from 'react';
import {Children, cloneElement, isValidElement, useMemo} from 'react';
import classNames from 'classnames';

import isString from '@tinkoff/utils/is/string';

import {TypographySize, useTypography} from '../../../hooks/typography';

import styles from './menu-item-hotkey.module.css';

type Props = {
    className?: string;
    hotkey: string;
};

export const MenuItemHotkey = ({children, className}: PropsWithChildren<Props>) => {
    const [typographyCls] = useTypography([
        {
            size: TypographySize.BodyS,
        },
    ]);

    const keys = useMemo(() => {
        if (isString(children)) {
            return <kbd className={typographyCls}>{children}</kbd>;
        }

        // учитываем вложенность kbd тега
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/kbd#usage_notes
        return Children.map(children, (el) => {
            if (isHTMLElementOfType(el, 'kbd')) {
                return cloneElement(el, {className: typographyCls});
            }

            return el;
        });
    }, [children, typographyCls]);

    return <span className={classNames(styles.shortcut, className)}>{keys}</span>;
};

function isHTMLElementOfType<ElementType extends keyof ReactHTML>(
    element: any,
    type: ElementType,
): element is ReactElement<HTMLAttributes<ElementType>> {
    return isValidElement(element) && element.type === type;
}
